// NOTE: used the Ant Design Modal component API as a model
// TODO: add type "delete": okText="Delete", okButtonProps={ danger: true }
import * as React from 'react'
import PropTypes from 'prop-types'
import { PrimeButton } from 'components-design-system'
import { primeButtonTypes } from 'components-design-system/PrimeButton/PrimeButton'
import './FormButtons.scss'
 
const FormButtons = ({
  size = "middle",
  className,
  style,
 
  // cancel
  cancelType = "default",
  cancelText = "Cancel",
  onCancel,
  cancelButtonProps = {},
 
  // submit
  okType = "primary",
  okText = "Submit",
  onOk,
  okButtonProps = {},
  htmlType="submit"
}) => {
  return <div
    className={`form-buttons${className ? ` ${className}` : ''}${size ? ` form-btns-size-${size}` : ''}`}
    style={style}
  >
    <PrimeButton
      type={cancelType}
      onClick={onCancel}
      size={size}
      {...cancelButtonProps}
    >
      {cancelText}
    </PrimeButton>
    <PrimeButton
      type={okType}
      onClick={onOk}
      size={size}
      htmlType={htmlType}
      {...okButtonProps}
    >
      {okText}
    </PrimeButton>
  </div>
}
 
FormButtons.propTypes = {
  size: PropTypes.oneOf(["small", "middle", "large"]),
  className: PropTypes.string,
  style: PropTypes.object,
  cancelType: PropTypes.oneOf(primeButtonTypes),
  cancelText: PropTypes.string,
  cancelButtonProps: PropTypes.object,
  onCancel: PropTypes.func,
  okType: PropTypes.oneOf(primeButtonTypes),
  okText: PropTypes.string,
  onOk: PropTypes.func,
  okButtonProps: PropTypes.object,
  children: PropTypes.node,
  htmlType: PropTypes.oneOf(["button", "submit", "reset"])

}
 
export default FormButtons